import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { RatePerClientForm } from '@/components/forms/RatePerClientForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditRatePerClientPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const [ratePerClientId, setRatePerClientId] = useState<number | null>(null)
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!id) {
      navigate('/rates-and-expenses/rate-per-client', { replace: true })
      return
    }

    const parsed = Number(id)
    if (Number.isNaN(parsed)) {
      navigate('/rates-and-expenses/rate-per-client', { replace: true })
      return
    }

    setRatePerClientId(parsed)
    setIsValidating(false)
  }, [id, navigate])

  const handleSuccess = () => {
    navigate('/rates-and-expenses/rate-per-client')
  }

  const handleCancel = () => {
    navigate('/rates-and-expenses/rate-per-client')
  }

  if (isValidating || ratePerClientId === null) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Rate per Client</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update rate per client details
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <RatePerClientForm ratePerClientId={ratePerClientId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}

